<template>
  <a class="a-logo" :href="homePath" @click.prevent="$router.push({ name: 'Home' })" aria-label="Mr Jeff Brașov — Acasă">
    <img
      :src="require(`@/assets/logos/${logo}.png`)"
      alt="Mr Jeff Brașov"
    />
  </a>
</template>
<script>
export default {
  props: {
    logo: {
      type: String,
      default: "default",
    },
  },
  computed: {
    homePath() {
      const lang = this.$route.params.lang || "ro";
      return `/${lang}/`;
    },
  },
};
</script>
<style lang="scss" scoped>
.a-logo {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
